const methods = {
    GET: 'GET',
    POST: 'POST',
    PATCH: 'PATCH',
    PUT: 'PUT',
    DELETE: 'DELETE'
}

let singleton = 'SINGLETON_ENFORCER';
let singletonEnforcer = 'SINGLETON';

export default class ResourceMap {
    constructor(enforcer) {
        if (enforcer != singletonEnforcer) {
            throw 'Cannot construct singleton ResourceMap.  Use ResourceMap.instance instead.';
        }

        this.methods = methods;
        this.resources = {};
        this.defaults = {
            url: '/',
            method: methods.GET,
            headers: {},
            body: '',
            onSuccess: () => {},
            onError: () => {}
        }
    }

    static get instance() {
        if (!this[singleton]) {
            this[singleton] = new ResourceMap(singletonEnforcer);
        }
        return this[singleton];
    }

    static get methods() {
        return methods;
    }

    static resource(type, resource) {
        let headers = Object.assign({}, resource.headers);

        resource = Object.assign({}, ResourceMap.instance.defaults, resource, {
            headers: headers
        });

        ResourceMap.instance.resources[type] = resource;
    }

    static getResource(type) {
        let resource = ResourceMap.instance.resources[type];
        if (resource) {
            let headers = Object.assign({}, ResourceMap.instance.defaults.headers, resource.headers);
            return Object.assign({}, ResourceMap.instance.defaults, resource, {
                headers: headers
            });
        } else {
            return false;
        }
    }

    static setDefaultHeaders(headers) {
        Object.assign(ResourceMap.instance.defaults, {
            headers
        });
    }

    static setAuthToken(token) {
        Object.assign(ResourceMap.instance.defaults, {
            headers: {
                Authorization: 'bearer ' + token
            }
        });
    }
}

if (process.env.NODE_ENV === 'development') {
    window.ResourceMap = ResourceMap;
}



// WEBPACK FOOTER //
// ./web-app/utils/resource-map.js